import { Stack } from '@mui/material';
import { EpisodeTitle, ThumbnailWithFallback } from './components';

export interface PodcastEpisodeCellProps {
  thumbnailUrl: string | undefined;
  episodeTitle: string;
  children?: React.ReactNode;
}

const PodcastEpisodeCell: React.FC<PodcastEpisodeCellProps> = ({
  thumbnailUrl,
  episodeTitle,
  children,
}) => (
  <Stack
    alignItems="center"
    direction="row"
    spacing={2}
    justifyContent="flex-start"
  >
    <ThumbnailWithFallback url={thumbnailUrl} />
    <Stack direction="column">
      <EpisodeTitle>{episodeTitle}</EpisodeTitle>
      {children}
    </Stack>
  </Stack>
);

export default PodcastEpisodeCell;
